<template>
  <span v-resize="checkMobile">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <!-- шапка в дизайне vehicles/list: сегмент скоупа («Архив» подсвечен,
         Активные/Неактивные ведут в список), поиск — в командной панели.
         Чекбоксы классов убраны (решение USER) -->
    <cars-command-bar view="archive" :filters="{ search }"
      search-testid="archive-cars-search"
      @input="search = $event.search" @refresh="getArchiveCars" />
    <v-card data-testid="archive-cars-page">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :loading="isLoading"
        :loading-text="$t('custom.loading_table')"
        :class="!isMobile ? '' : 'is-mobile'"
        :items="cars"
        :search="search"
        sort-by="sort"
        :sort-desc="true"
        item-key="id"
        :items-per-page="50"
        mobile-breakpoint="100"
        :footer-props="tableFooterProps([20, 50, 100, -1])"
      >
        <template slot="header" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="item" slot-scope="props">
          <tr @dblclick="replaceToCar(props.item)">
            <td class="text-center" :key="props.item.id">
              <router-link :to="{ path: `/cars/${props.item.id}` }">{{
                props.item.car_name
              }}</router-link>
            </td>
            <td class="text-center">{{ props.item.code }}</td>
            <td class="justify-center layout px-0">
              <v-icon color="error" @click="deleteItem(props.item)">
                mdi-delete-forever
              </v-icon>
            </td>
            <td class="text-center text-no-wrap">{{ props.item.number }}</td>
            <td class="text-center">{{ props.item.color }}</td>
            <td class="text-center">{{ props.item.year }}</td>
            <td class="text-center">{{ props.item.price_hour }}</td>
            <td class="text-center">{{ props.item.deposit }}</td>
          </tr>
        </template>
        <template slot="no-data">
          {{ $t("custom.no_data_in_table") }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
          {{ $t("tables.no_search_result", { msg: search }) }}
        </v-alert>
      </v-data-table>
    </v-card>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import CarsCommandBar from "@/components/dashboard/cars/CarsCommandBar.vue";
// moment.locale("ru");
export default {
  pullToRefresh: true,
  data() {
    return {
      cars: [],
      all_cars: [],
      editedCar: "",
      bookings: [],
      filtred_bookings_car_ids: [],
      error: "",
      snack_text: "",
      snack_mode: "",
      snack_color: "",
      search: "",
      sort_date_range: "",
      dialog: false,
      options: {
        sortBy: "car_name",
      },
      selected: [],
      headers: [
        { text: this.$t("cars.name"), value: "car_name", align: "center" },
        { text: this.$t("custom.code"), value: "code", align: "center" },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        {
          text: this.$t("common.license_plate"),
          sortable: false,
          value: "number",
          align: "center",
        },
        { text: this.$t("custom.color"), sortable: false, align: "center" },
        { text: this.$t("custom.year"), sortable: false, align: "center" },
        {
          text: this.$t("custom.price_for_hour"),
          sortable: false,
          align: "center",
        },
        { text: this.$t("bookings.deposit"), sortable: false, align: "center" },
      ],
      isMobile: false,
      isLoading: false,
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.getArchiveCars();
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
  },
  methods: {
    // вынесено из created: переиспользуется кнопкой «Обновить» командной панели
    getArchiveCars() {
      this.isLoading = true;
      this.cars = [];
      this.all_cars = [];
      this.axios
        .get("/api/v1/archive_cars.json", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.cars.push(element);
            this.all_cars.push(element);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_archive_cars"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },
    replaceToCar(car) {
      this.$router.push({ path: `/cars/${car.id}` });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    deleteItem(car) {
      if (this.isAdminPlus) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.isLoading = true;
            this.axios
              .delete(`/api/v1/cars/${car.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then(() => {
                this.cars.splice(this.cars.indexOf(car), 1);
              })
              .catch((error) =>
                this.setError(error, this.$t("errors.remove_archive_cars"))
              );
            this.$notify(this.$t("custom.deleted"), this.$t("cars.delete"), "success");
            this.isLoading = false;
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
  },
  components: {
    CarsCommandBar,
  },
};
</script>
